var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.971,
    height: 12.777,
    viewBox: "0 0 15.971 12.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-balance-scale",
    "data-name": "Icon awesome-balance-scale",
    d: "M6.388,8.385h0c0-.4.033-.218-2.122-4.53a1.2,1.2,0,0,0-2.143,0C-.051,8.2,0,7.994,0,8.385H0c0,1.1,1.43,2,3.194,2S6.388,9.487,6.388,8.385ZM3.194,4.392l1.8,3.594H1.4ZM15.971,8.385c0-.4.033-.218-2.122-4.53a1.2,1.2,0,0,0-2.143,0C9.531,8.2,9.583,7.994,9.583,8.385h0c0,1.1,1.43,2,3.194,2s3.194-.894,3.194-2Zm-4.99-.4,1.8-3.594,1.8,3.594Zm2.2,3.194H8.784V3.824A2,2,0,0,0,9.942,2.4h3.234a.4.4,0,0,0,.4-.4V1.2a.4.4,0,0,0-.4-.4h-3.6A1.978,1.978,0,0,0,6.4.8h-3.6a.4.4,0,0,0-.4.4V2a.4.4,0,0,0,.4.4H6.029A2,2,0,0,0,7.187,3.824V11.18H2.795a.4.4,0,0,0-.4.4v.8a.4.4,0,0,0,.4.4H13.176a.4.4,0,0,0,.4-.4v-.8A.4.4,0,0,0,13.176,11.18Z",
    fill: "#64c2c8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDas);
export default __webpack_public_path__ + "static/media/DAS.cdb6ebeed0da2e52657f6c71c60bbdaf.svg";
export { ForwardRef as ReactComponent };